module.exports = __webpack_public_path__ + "img/rca-logo.89a3cb77.svg";